import { setCookie, getCookie } from "./cookies";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // geen O/0/I/1
const SESSION_KEY = "sl_lead_ref";
const COOKIE = "sl_ref";

const gen = () =>
  "SL-" +
  Array.from(crypto.getRandomValues(new Uint8Array(5)))
    .map((b) => CHARS[b % CHARS.length])
    .join("");

let ref = null;

export const getLeadRef = () => {
  if (ref) return ref;
  ref = sessionStorage.getItem(SESSION_KEY) || getCookie(COOKIE);
  if (!ref) {
    ref = gen();
    sessionStorage.setItem(SESSION_KEY, ref);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "lead_ref_created", lead_ref: ref });
  } else {
    sessionStorage.setItem(SESSION_KEY, ref);
  }
  return ref;
};

// na marketing-consent: persisteer in first-party cookie (90 dagen)
export const persistLeadRef = () => {
  if (ref) setCookie(COOKIE, ref, 90);
};
